import { Wrapper as Section } from 'components/shared/Section/styles'
import styled from 'styled-components'

export const Wrapper = styled(Section)`
    textarea,
    input[type='number'] {
        cursor: default !important;
    }
`
